import { takeUntil } from 'rxjs/operators';
import { InventoryItemDataService } from './../../../sell-shared/services/inventory-item-data.service';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { get } from 'lodash';
import {
  InventoryItem,
  InventoryItemDetail,
  SellerOfferAction,
  SellerOfferActionDto,
  SellerOfferDto,
  multiLanguageAlphaNumericRegexHelper
} from 'remarketing-angular-library';
import { Subject, Observable } from 'rxjs';
import {
  CharacterCountComponent, CharacterCountDirective,
  DatalistItemComponent,
  ModalComponent
} from 'remarketing-ui-components-lib';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { OfferActionInterface } from '../../interfaces/offer-action.interface';
import { SellWarnings } from '../../../../helpers/sell-warnings';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { CurrencyFormatService } from 'smartauction-frontend-micro-library';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'lib-accept',
    templateUrl: './accept.component.html',
    styleUrls: ['./accept.component.scss'],
    imports: [
        TranslocoDirective,
        DatalistItemComponent,
        ReactiveFormsModule,
        CharacterCountComponent,
        ModalComponent,
        CommonModule,
        CharacterCountDirective
    ]
})
export class AcceptComponent implements OnInit, OnDestroy {
  private _isVisible = false;
  characterCountData: any;
  @Input() set isVisible(isVisible: boolean) {
    this._isVisible = isVisible;
    if (this._isVisible) {
      setTimeout(() => this.heading.nativeElement.focus());
    }
  }
  get isVisible() {
    return this._isVisible;
  }
  @Input() inventoryItem: InventoryItem;
  @Input() offer: Partial<SellerOfferDto>;
  @Input() tenantName: string;
  @ViewChild(ModalComponent) modal: ModalComponent;
  @ViewChild('heading') heading: ElementRef<HTMLHeadingElement>;
  destroyed$ = new Subject();
  @Output() cancel = new EventEmitter();
  @Output() action = new EventEmitter<OfferActionInterface>();

  commentForm: UntypedFormGroup;
  messageWarningText = '';
  offerErrorCode: string;
  localErrorMessage: string;
  localErrorState$: Observable<{ message: string; offerUuid: string }> = this.inventoryItemDataService.localErrorState;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly inventoryItemDataService: InventoryItemDataService,
    private readonly translocoService: TranslocoService,
    private readonly currencyFormatService: CurrencyFormatService
  ) {}

  ngOnInit() {
    this.commentForm = this.formBuilder.group({
      offerComment: ['']
    });

    this.localErrorState$.pipe(takeUntil(this.destroyed$)).subscribe(localErrorState => {
      if (localErrorState.offerUuid) {
        localErrorState.offerUuid === this.offer.offerUuid
          ? (this.localErrorMessage = localErrorState.message)
          : (this.localErrorMessage = null);
      } else {
        this.localErrorMessage = null;
      }
    });
    this.translocoService.selectTranslateObject('UIComponents').subscribe(translatedObj => {
      this.characterCountData = translatedObj.characterCount;
    });
  }

  get modalId() {
    return `accept-${this.offer.auctionItemUuid}`;
  }

  get title() {
    return `${this.detail('modelYear')} ${this.detail('make')} ${this.detail('model')} ${this.detail(
      'trim'
    )} VIN <div class="d-inline stockwave-bid-buy-vin">${this.detail('vin')}</div>`;
  }

  detail(key: keyof InventoryItemDetail): string {
    return get(this.itemDetails, key, '');
  }

  get itemDetails(): any | {} {
    return get(this.inventoryItem, 'itemDetail', {});
  }

  get(path: string, otherwise: any = 'N/A'): string {
    return get(this.offer, path, otherwise);
  }

  offerResponseErrorCode(errorCode: string) {
    this.offerErrorCode = errorCode;
    if (this.offerErrorCode === 'F-REMPLT-AIS-ONH') {
      this.messageWarningText = SellWarnings.getwarningMessage(this.offerErrorCode);
      this.modal.show();
    }
  }

  replaceInvalidCharacters(e) {
    e.target.value = multiLanguageAlphaNumericRegexHelper(e.target.value);
  }

  accept() {
    let acceptLowerOffer = false;
    if (this.offerErrorCode === 'F-REMPLT-AIS-ONH') {
      this.modal.close();
      acceptLowerOffer = true;
    }
    const payload: SellerOfferActionDto = {
      offerUuid: this.offer.offerUuid,
      requestedAction: SellerOfferAction.ACCEPT,
      comment: this.commentForm.get('offerComment').value,
      amount: this.offer.amount
    };
    const analyticsPayload = {
      formValues: {
        name: 'Accept Offer',
        status: null,
        errors: null,
        type: '',
        step: '1',
        stepname: '',
        items: [
          {
            allow: 'yes',
            error: null,
            name: 'Vehicle UUID',
            track: 'yes',
            value: this.inventoryItem ? this.inventoryItem.inventoryItemUuid : null
          },
          {
            allow: 'yes',
            error: null,
            name: 'Buyer Offer',
            track: 'yes',
            value: this.offer.amount
          }
        ]
      }
    };
    const data = {
      payload,
      analyticsPayload,
      acceptLowerOffer
    };
    this.action.emit(data);
  }

  close() {
    this.offerErrorCode = '';
    this.modal.close();
  }

  formatCurrency(currency) {
    return this.currencyFormatService.formatCurrency(currency, false).replaceAll('-', '');
  }

  ngOnDestroy(): void {
    this.localErrorMessage = null;
    this.inventoryItemDataService._localErrorState.next({ message: null, offerUuid: null });

    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
